import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./AgencyOperationStatus";
import Modal from "react-bootstrap/Modal";
import { Button, Tooltip, Overlay, Tab, Table, Spinner } from "react-bootstrap";
import AuthService from "../../services/auth.service";
import AuthService2 from "../../services/auth.serviceV2";
import Agencyservice from "../../services/agency.service";
import * as turf from "@turf/turf";
import L, { point } from "leaflet";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Polygon,
  GeoJSON,
  useMapEvent,
  LayersControl,
  AttributionControl,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import toGeoJSON from "@mapbox/togeojson";
import PaginationS from "../admin/Pagination";

///React-Icon 
import { LuCopyPlus, LuCopyCheck, LuCopyMinus } from "react-icons/lu";
import { FaRegEdit } from "react-icons/fa";
import { TbDrone } from "react-icons/tb";
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
});

const AgencyOperationStatus = () => {
  const [allArea, setAllArea] = useState({});
  const [showInfomation, setShowInfomation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [waitstatus3, setWaitstatus3] = useState("");
  const [items, setItems] = useState([]);
  const [droneArray, setDroneArray] = useState([]);

  const [selectedInformation, setSelectedInformation] = useState([]);
  const [showApproveDroneList, setShowApproveDroneList] = useState(false);
  const [showUnApproveDroneList, setShowUnApproveDroneList] = useState(false);
  const [modalLoading, setModal_Loading] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [target, setTarget] = useState(null);
  const [valuetool, setValuetool] = useState();
  const [getOp_Reload, setGetOp_Reload] = useState(true);
  const [clipboard_icon, setclipboard_Icon] = useState(<LuCopyPlus style={{ width: "25px", height: "25px" }} />);
  const ClipBoard = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
  const ClipBHover = () => {
    setclipboard_Icon(<LuCopyMinus style={{ width: "25px", height: "25px" }} />);
  };

  const ClipBClick = (text) => {
    setclipboard_Icon(<LuCopyCheck style={{ width: "25px", height: "25px", color: "green" }} />);
    ClipBoard(text)
  };
  const handleClick = (event) => {
    setShowTooltip(!showTooltip);
    setTarget(event.target);
    setValuetool(event.target.value);
  };
  useEffect(() => {
    getOperation();
  }, [getOp_Reload]);

  const getOperation = () => {
    Agencyservice.Opearationdata()
      .then((response) => {
        console.log(response.data);
        if (response && response.data && Array.isArray(response.data)) {
          setItems([...response.data].reverse());
          console.log(items);
          setLoading(true);
        } else {
          console.error("Received unexpected data format or no data.");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const droneCoopDataapprove = (operation_id) => {
    Agencyservice.Opearationdata(operation_id)
      .then((response) => {
        let arr = [];
        if (response.data.drone_pilot_data.length !== 0) {
          response.data.drone_pilot_data.map((feature, index) => {
            if (feature.approve_status === 2) {
              console.log(response.data.drone_pilot_data);
              arr.push(response.data.drone_pilot_data[index]);
            }
          });
          console.log(arr);
          setDroneArray(arr);
        }
        setShowApproveDroneList(true);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const droneCoopData = (operation_id) => {
    if (!operation_id) return;

    Agencyservice.Opearationdata(operation_id)
      .then((response) => {
        console.log(response.data);
        const listwaitapprove = response.data.drone_pilot_data.filter(
          (item) => item.approve_status === 1
        );
        console.log(listwaitapprove);
        setDroneArray(listwaitapprove);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const updateCoopData = (operation_co_id, status) => {
    Agencyservice.ResponseOperationRequest(operation_co_id, status)
      .then(() => {
        setShowUnApproveDroneList(false);
        setModal_Loading(true);
        setTimeout(() => {
          setGetOp_Reload(!getOp_Reload);
          handleClose();
        }, 2000);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
      });
  };

  function formatDate(input) {
    // Parse the date string to create a new Date object
    const date = new Date(input);

    // Extract day, month, year, hours, and minutes
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    // Return the formatted date
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  const handleClose = () => {
    setShowApproveDroneList(false);
    setShowUnApproveDroneList(false);
    setDroneArray([]);
    setShowInfomation(false);
    setModal_Loading(false);
  };

  const handleShowInformation = () => {
    setShowInfomation(true);
  };

  const handleApprovedDroneList = (operation_id) => {
    droneCoopDataapprove(operation_id);
  };

  const handleUnApprovedDroneList = (operation_id) => {
    droneCoopData(operation_id);
    setShowUnApproveDroneList(true);
  };

  ///pagination param
  const [searchValues, setSeachValue] = useState([
    "id",
    "start_time",
    "end_time",
  ]);
  const [portionData, setPortionData] = useState([]);
  const [startArr, setStartArr] = useState(0);
  const handlePortionChange = (newPortion, startarr) => {
    console.log(newPortion);
    setPortionData(newPortion);
    setStartArr(startarr);
  };

  function center_Polygon(area) {
    area.map((value) => {
      console.log(value);
    });
    let polygon = turf.polygon([area]);
    let centroid = turf.centroid(polygon);
    console.log(centroid);
    return centroid; //return Geojson Form {tpye,props,geometry:{type,coordinates}}
  }
  const Modal_Equl_Null = () => {
    return <Modal></Modal>;
  };
  function Cancel_Operation(operation_id) {
    try {
      AuthService2.DeAuthorizedOperation(operation_id)
        .then((res) => {
          window.location.reload();
        })
        .catch((err) => {
          alert("ไม่พบข้อมูล กรุณาลองใหม่อีกครั้ง");
        });
    } catch (err) {
      alert("เกิดข้อผิดพลาด");
    }
  }
  return (
    <div>
      {showApproveDroneList && (
        <Modal
          show={showApproveDroneList}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              โดรนที่เข้าร่วมรหัส {selectedInformation[0]}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ margin: "0", padding: "0" }}>
            <div
              className="container-main"
              style={{ width: "90%", marginLeft: "5%" }}
            >
              <div style={{ textAlign: "end" }}>
                <p>จำนวน {droneArray.length} รายการ</p>
              </div>
              <Table
                striped
                responsive
                overflow
                bordered={false}
                hover
                className="table-main"
                style={{
                  marginTop: "0px",
                }}
              >
                <thead>
                  <tr>
                    <th className="table-space" style={{ width: "10%" }}>
                      ลำดับ
                    </th>
                    <th className="table-space">ชื่อนักบิน</th>
                    <th className="table-space">โมเดลของโดรน</th>
                    <th className="table-space">ยกเลิกนักบิน</th>
                  </tr>
                </thead>
                <tbody>
                  {droneArray.map((item, index) => (
                    <>
                      <tr key={item.id}>
                        <td className="table-space">{index + 1}</td>
                        <td className="table-space">{item.pilot_name}</td>
                        <td className="table-space">
                          {item.drone_brand_model}
                        </td>
                        <td className="table-space">
                          <div
                            className="custom-btn btnCancel"
                            style={{
                              margin: "auto",
                              fontSize: "16px",
                              width: "150px",
                              height: "30px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            onClick={() => {
                              console.log("Approved");
                              updateCoopData(item.operation_co_id, 3);
                            }}
                          >
                            ยกเลิก
                          </div>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ width: "100%", height: "100%" }}>
              <div
                style={{
                  display: "flex",
                }}
              ></div>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {showUnApproveDroneList && (
        <Modal
          show={showUnApproveDroneList}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              โดรนที่เข้าร่วมรหัส {selectedInformation[0]}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ margin: "0", padding: "0" }}>
            <div
              className="container-main"
              style={{ width: "90%", marginLeft: "5%" }}
            >
              <div style={{ textAlign: "end" }}>
                <p>จำนวน {droneArray.length} รายการ</p>
              </div>
              <Table
                striped
                responsive
                overflow
                bordered={false}
                hover
                className="table-main"
                style={{
                  marginTop: "0px",
                }}
              >
                <thead>
                  <tr>
                    <th className="table-space" style={{ width: "10%" }}>
                      ลำดับ
                    </th>
                    <th className="table-space">ชื่อนักบิน</th>
                    <th className="table-space">โมเดลของโดรน</th>
                    <th className="table-space">ยืนยินการขออนุญาต</th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    marginTop: "0px",
                    height: "auto",
                    maxHeight: "0px",
                    overflowY: "auto",
                  }}
                >
                  {droneArray.map((item, index) => (
                    <tr key={index}>
                      {item.approve_status === 1 ? (
                        <>
                          <td className="table-space">{index + 1}</td>
                          <td className="table-space">{item.pilot_name}</td>
                          <td className="table-space">
                            {item.drone_brand_model}
                          </td>
                          <td className="table-space">
                            <div
                              style={{
                                display: "flex",
                              }}
                            >
                              {waitstatus3 ? (
                                <div
                                  style={{
                                    backgroundColor: "yellow",
                                    width: "90%",
                                    margin: "0px auto",
                                    color: "black",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    console.log("Approved");
                                    updateCoopData();
                                  }}
                                >
                                  รอการบินพลเรือนอนุมัติ
                                </div>
                              ) : (
                                <>
                                  <div
                                    className="custom-btn btnSave"
                                    style={{
                                      fontSize: "16px",
                                      width: "120px",
                                      height: "30px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                    onClick={() => {
                                      console.log("Approved");
                                      updateCoopData(item.operation_co_id, 2);
                                    }}
                                  >
                                    อนุมัติ
                                  </div>
                                  <div
                                    className="custom-btn btnCancel"
                                    style={{
                                      marginLeft: "10px",
                                      fontSize: "16px",
                                      width: "120px",
                                      height: "30px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                    onClick={() => {
                                      console.log("UnApproved");
                                      updateCoopData(item.operation_co_id, 3);
                                    }}
                                  >
                                    ไม่อนุมัติ
                                  </div>
                                </>
                              )}
                            </div>
                          </td>
                        </>
                      ) : (
                        ""
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
        </Modal>
      )}
      {showInfomation === true && (
        <Modal
          show={showInfomation}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              ลำดับที่ {selectedInformation[0]} รหัสการปฏิบัติการ{" "}
              {selectedInformation[1]}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ margin: "0", padding: "0" }}>
            <div>
              <MapContainer
                center={
                  center_Polygon(selectedInformation[2]).geometry.coordinates
                }
                zoom={15}
                keyboard={true}
                style={{ width: "100%", height: "50vh", zIndex: 1 }}
              >
                <TileLayer
                  style={{ zIndex: 2 }}
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Polygon
                  pathOptions={{ color: "blue" }}
                  positions={selectedInformation[2]}
                />
              </MapContainer>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ width: "100%", height: "100%" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{ width: "50%", height: "100%", textAlign: "center" }}
                >
                  <h4>เวลาเริ่มต้น : {selectedInformation[3]}</h4>
                </div>
                <div
                  style={{ width: "50%", height: "100%", textAlign: "center" }}
                >
                  <h4>เวลาสิ้นสุด : {selectedInformation[4]}</h4>
                </div>
                {selectedInformation[5] === "อนุมัติ" ? (
                  <div>
                    <button
                      className="custom-btn btnCancel"
                      style={{ width: "200px", height: "auto" }}
                      onClick={() => {
                        Cancel_Operation(selectedInformation[0]);
                      }}
                    >
                      ยกเลิกภารกิจ
                    </button>
                  </div>
                ) : (
                  <div>
                    <button
                      disabled
                      className="custom-btn btnDisable"
                      style={{ width: "200px", height: "auto", color: "black" }}
                    >
                      ยกเลิกภารกิจ
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      <div
        className="container-main"
        style={{ width: "90%", marginLeft: "5%" }}
      >
        <div className="table-card-header">
          <h4 className="header-main" style={{ color: "white" }}>
            รายการปฏิบัติการ
          </h4>
        </div>
        {loading === true ? (
          <div>
            <div style={{ textAlign: "end", marginTop: "35px" }}>
              <p>จำนวน {items.length} รายการ</p>
            </div>
            <Table
              striped
              bordered={false}
              hover
              className="table-main"
              style={{ marginTop: "0px" }}
            >
              <thead>
                <tr>
                  <th className="table-space" style={{ width: "7%" }}>
                    ลำดับ
                  </th>
                  <th className="table-space" style={{ width: "26%" }}>
                    รหัสปฏิบัติการ
                  </th>
                  <th className="table-space">เวลาเริ่มภารกิจ</th>
                  <th className="table-space">เวลาสิ้นสุดภารกิจ</th>
                  <th className="table-space" style={{ width: "10%" }}>
                    สถานะ
                  </th>
                  <th className="table-space" style={{ width: "7%" }}>
                    โดรนที่เข้าร่วม
                  </th>
                  <th className="table-space" style={{ width: "10%" }}>
                    โดรนที่รอการอนุมัติ
                  </th>
                  <th className="table-space" style={{ width: "10%" }}>
                    ตรวจสอบข้อมูลตำแหน่ง
                  </th>
                </tr>
              </thead>
              <tbody>
                {portionData.map((item, index) => (
                  <tr key={index + 1}>
                    <td className="table-space">{startArr + (index + 1)}</td>
                    <td className="table-space">
                      <Button
                        onClick={(e) => handleClick(e)}
                        value={item.id}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#575757",
                          fontSize: "20px",
                        }}
                      >
                        {item.id.substring(0, 13) + " ..."}
                      </Button>
                      <Overlay
                        show={showTooltip}
                        target={target}
                        placement="top"
                      //container={document.body}
                      //containerPadding={20}
                      >
                        <Tooltip id="tooltip">
                          <div>{valuetool}</div>
                          <div
                            style={{ marginTop: "5px" }}
                            onMouseEnter={ClipBHover}
                            onClick={() => ClipBClick(valuetool)}>
                            {clipboard_icon}
                          </div>
                        </Tooltip>
                      </Overlay>
                    </td>
                    <td className="table-space">
                      {item.start_time.substring(0, 10)}
                      <br />
                      {item.start_time.substring(11, 16)}
                    </td>
                    <td className="table-space">
                      {item.end_time.substring(0, 10)}
                      <br />
                      {item.end_time.substring(11, 16)}
                    </td>

                    <td
                      className="table-space"
                      style={{
                        color: (() => {
                          switch (item.operation_status_text) {
                            case "อนุมัติ":
                            case "อนุญาตให้ขึ้นบิน":
                            case "เสร็จภารกิจ":
                              return "#008000";
                            case "ภารกิจถูกยกเลิก":
                            case "ยกเลิกภารกิจ":
                              return "red";
                            default:
                              return "#FF8C00";
                          }
                        })(),
                      }}
                    >
                      {item.operation_status_text ?? "ติดต่อเจ้าหน้าที่"}
                    </td>

                    <td className="table-space">
                      <TbDrone
                        style={{ cursor: "pointer", fontSize: "25px" }}
                        className="investigate-button"
                        onClick={() => {
                          setSelectedInformation([item.operation_id]);
                          handleApprovedDroneList(item.operation_id);
                        }}
                      />
                      {item.operation_area.aircraft_count >= 0 ? (
                        <sup style={{ color: "green", fontWeight: "500" }}>
                          {item.operation_area.aircraft_count}
                        </sup>
                      ) : null}
                    </td>
                    <td className="table-space">
                      <TbDrone
                        style={{ cursor: "pointer", fontSize: "25px" }}
                        className="investigate-button"
                        onClick={() => {
                          setSelectedInformation([item.operation_id]);
                          handleUnApprovedDroneList(item.operation_id);
                        }}
                      />
                      {item.operation_area.aircraft_count_pending >= 0 ? (
                        <sup style={{ color: "red", fontWeight: "500" }}>
                          {item.operation_area.aircraft_count_pending}
                        </sup>
                      ) : null}
                    </td>
                    <td className="table-space">
                      <FaRegEdit
                        style={{ cursor: "pointer", fontSize: "25px" }}
                        className="investigate-button"
                        onClick={() => {
                          const storeArray = [];
                          const center_point = [];
                          const polygonData =
                            item.operation_area.Volume3D.outline_polygon
                              .vertices;
                          polygonData.map((content, index) => {
                            storeArray.push([content.Lat, content.Lon]);
                            center_point.push([content.Lon, content.Lat]);
                          });

                          setSelectedInformation([
                            item.operation_id,
                            item.id,
                            storeArray,
                            formatDate(item.start_time),
                            formatDate(item.end_time),
                            item.operation_status_text,
                          ]);
                          handleShowInformation();
                          setAllArea(item.area);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <Table
            striped
            bordered={false}
            hover
            className="table-main"
            style={{ marginTop: "60px" }}
          >
            <thead>
              <tr style={{ fontSize: "20px" }}>
                <th className="table-space" style={{ width: "7%" }}>
                  ลำดับ
                </th>
                <th className="table-space" style={{ width: "26%" }}>
                  รหัสปฏิบัติการ
                </th>
                <th className="table-space">เวลาเริ่มภารกิจ</th>
                <th className="table-space">เวลาสิ้นสุดภารกิจ</th>
                <th className="table-space" style={{ width: "10%" }}>
                  สถานะ
                </th>
                <th className="table-space" style={{ width: "7%" }}>
                  โดรนที่เข้าร่วม
                </th>
                <th className="table-space" style={{ width: "10%" }}>
                  โดรนที่รอการอนุมัติ
                </th>
                <th className="table-space" style={{ width: "10%" }}>
                  ตรวจสอบข้อมูลตำแหน่ง
                </th>
              </tr>
            </thead>
            <tbody>
              <td colSpan={6}>
                <div
                  className="loading-container"
                  style={{ height: "20vh", width: "100%" }}
                >
                  {" "}
                  <Spinner animation="border" variant="secondary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              </td>
            </tbody>
          </Table>
        )}
        <PaginationS
          data={items}
          onPortionChange={handlePortionChange}
          searchValue={searchValues}
        />
      </div>
      <Modal size="sm" show={modalLoading} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Body>
            <div class="container-modal-loding">
              <div class="flex">
                <div class="loader" />
              </div>
              <div class="load-text">กรุณารอสักครู่...</div>
            </div>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    </div>
  );
};

export default AgencyOperationStatus;
